import styled from 'styled-components';
import { Row } from 'antd';

export const ContainerRow = styled(Row)`
  margin-bottom: 16px;

  div.ant-typography {
    margin: 0;
    width: fit-content;
  }

  .ant-statistic-content {
    overflow: hidden;
  }
  .ant-badge {
    height: 100%;
    .ant-badge-status-dot {
      width: 14px;
      height: 14px;
    }
  }

  article {
    color: black !important;
    font-size: 4.5rem;
    background: white;
    text-align: center;
    font-weight: 600;
    padding: 50px 0;

    @media (max-width: 1650px) {
      font-size: 3rem;
    }

    @media (max-width: 800px) {
      font-size: 2rem;
    }

    @media (max-width: 500px) {
      font-size: 1.5rem;
      padding: 25px 0;
    }
  }

  h1 {
    color: black !important;
    font-size: 1rem;
    background: white;
    text-align: center;
    font-weight: 600;
    margin: 0;
    height: 40px;
    padding: 16px 4px 0;

    @media (max-width: 500px) {
      font-size: 0.8rem;
    }

    @media (max-width: 400px) {
      font-size: 0.6rem;
      padding-top: 8px;
    }
  }
`;
